import { Header } from "../header/header";
import { BookNow } from "../../pages/booknow/booknow";
import "./home.css";
import { Gallery } from "../../pages/gallery/gallery";
import Rooms from "../../pages/rooms/rooms";
export const Home = () => {
  return (
    <div className="home-page">
      <Header />
      <Gallery />
      <Rooms />
      <BookNow />
      <section>
        <main></main>
      </section>
    </div>
  );
};
